import { useEffect } from "react";
import { clearBreadcrumbEntity, publishBreadcrumbEntity } from "../services/breadcrumbService";

// Publica o nome do registro aberto para o breadcrumb da barra superior (ver breadcrumbService).
// Sem label (ainda carregando), a trilha mostra o rótulo genérico. Ao sair da página, limpa.
export default function useBreadcrumbEntity(path, label) {
  useEffect(() => {
    if (!path || !label) return;
    publishBreadcrumbEntity({ path, label });
  }, [path, label]);

  useEffect(() => () => clearBreadcrumbEntity(), []);
}
